export const DEFAULT_LORA_SCALE = 0.5;
